import { c as _c } from "react/compiler-runtime";
import { useTourTelesales } from "@website/accommodation-ui/tour-empty-state/hooks";
import { EmptyStateResponse, TelesalesFromDataType } from "@website/accommodation-ui/tour-empty-state/types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { TextField } from "@website/ui/text-field";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { Control, Controller } from "react-hook-form";
interface Properties {
  cityFromTitle?: string;
  cityToTitle?: string;
  data: Array<EmptyStateResponse>;
}
export const TourEmptyState = t0 => {
  const $ = _c(21);
  const {
    cityFromTitle,
    cityToTitle,
    data
  } = t0;
  const {
    redirect,
    FaDate,
    control,
    handleSubmit,
    handleSetEvent,
    isPending
  } = useTourTelesales(data);
  let t1;
  if ($[0] !== FaDate || $[1] !== cityFromTitle || $[2] !== cityToTitle || $[3] !== data || $[4] !== redirect) {
    t1 = Array.isArray(data) && data?.length > 0 && <div className="bg-transparent-secondary p-4 md:rounded-xl"><div className="text-base md:text-lg">تاریخ تورهای موجود {`تور ${cityFromTitle} به ${cityToTitle}`}</div><div className="text-caption text-on-surface-medium-emphasis mt-2">با انتخاب یکی از تاریخ های زیر تور مورد نظر خود را انتخاب کنید.</div><div className="grid grid-cols-1 gap-4 py-4 md:grid-cols-2">{data.map((item, index) => <div className="bg-background flex justify-between rounded-xl px-3 py-4" key={`${item.departureDate}-${index++}`}><div className="flex flex-col gap-1"><div className="flex items-center gap-2"><div className="md:text-subtitle-2 text-extra-caption">{FaDate(item?.departureDate)} تا{" "}{FaDate(item?.returnDate)}</div><div className="bg-transparent-secondary text-overline md:text-caption text-secondary rounded px-2 py-1">{numberConvert(item?.stayCount, {
                  locale: "fa"
                })} شب</div></div><div className="text-on-surface-medium-emphasis text-extra-caption">قیمت به ازای یک نفر از{" "}<span className="md:text-subtitle-1 text-extra-caption">{numberConvert(numberSeparator((item?.minPrice / 10).toFixed(0)), {
                  locale: "fa"
                })}</span>{" "}تومان</div></div><Button className="!h-10 md:!h-12" color="secondary" onClick={() => redirect(item)} variant="contained">مشاهده</Button></div>)}</div></div>;
    $[0] = FaDate;
    $[1] = cityFromTitle;
    $[2] = cityToTitle;
    $[3] = data;
    $[4] = redirect;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><div>ساخت تور سفارشی شما</div><div className="text-caption text-on-surface-medium-emphasis mt-2">با وارد کردن شماره تماس خود و ثبت درخواست کارشناسان ما تور مورد نظر شما را برایتان خواهند ساخت.</div></div>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== handleSetEvent || $[8] !== handleSubmit) {
    t3 = handleSubmit(handleSetEvent);
    $[7] = handleSetEvent;
    $[8] = handleSubmit;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = control as unknown as Control<TelesalesFromDataType>;
  let t5;
  if ($[10] !== t4) {
    t5 = <div className="text-body-2 text-on-surface-high-emphasis max-md:w-4/5"><Controller control={t4} name="freeTransferMobileNumber" render={_temp} /></div>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isPending) {
    t6 = <Button children={"\u062B\u0628\u062A"} className="!h-14 w-1/5 md:!w-20" color="secondary" loading={isPending} type="submit" variant="outline" />;
    $[12] = isPending;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className="bg-background my-5 grid grid-cols-1 rounded-xl p-4 md:grid-cols-2">{t2}<form className="flex gap-2 max-md:mt-6 md:justify-end" onSubmit={t3}>{t5}{t6}</form></div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t7) {
    t8 = <>{t1}{t7}</>;
    $[18] = t1;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
function _temp(t0) {
  const {
    field,
    fieldState: t1
  } = t0;
  const {
    error
  } = t1;
  return <TextField StartIcon={<MaterialIcon name="phone_iphone" />} className="max-md:!w-full" error={Boolean(error)} helperText={error?.message} inputMode="text" placeholder={"\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644"} {...field} />;
}